<template>
  <v-card outlined class="pl-1 pr-1 date-card">
    <v-row no-gutters>
      <v-col>
        <ejs-datepicker
          ref="startDateObj"
          :locale="locale"
          v-model="mStartDate"
          :format="dateFormat"
          :allowEdit="false"
          :showClearButton="false"
          :enableMask="true"
          :focus="onStartDateFocus"
          @change="onDateChange"
        ></ejs-datepicker>
      </v-col>
      <v-col cols="1" class="text-center"> - </v-col>
      <v-col>
        <ejs-datepicker
          ref="endDateObj"
          :locale="locale"
          v-model="mEndDate"
          :format="dateFormat"
          :allowEdit="false"
          :showClearButton="false"
          :enableMask="true"
          :focus="onEndDateFocus"
          :min="startDate"
          @change="onDateChange"
        ></ejs-datepicker>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import Vue from "vue";
import { DatePickerPlugin } from "@syncfusion/ej2-vue-calendars";
import { loadCldr, L10n } from "@syncfusion/ej2-base";
import * as localeText from "@/Langs/locale.json";
loadCldr(
  require("cldr-data/supplemental/numberingSystems.json"),
  require("cldr-data/main/ja/ca-gregorian.json"),
  require("cldr-data/main/ja/numbers.json"),
  require("cldr-data/main/ja/timeZoneNames.json")
);
L10n.load(localeText.default);

Vue.use(DatePickerPlugin);

export default {
  name: "StartEndTimeDatePicker",
  props: {
    startDate: Date,
    endDate: Date,
  },
  data() {
    return {};
  },
  computed: {
    dateFormat() {
      return this.locale !== "ja" ? "dd-MM-yyyy" : "yyyy-MM-dd";
    },
    locale() {
      return this.$i18n.locale;
    },
    formatedDate() {
      return new Intl.DateTimeFormat(
        this.selectedLang,
        this.dateOptions
      ).format(this.date);
    },
    mStartDate: {
      get() {
        return this.startDate;
      },
      set(value) {
        this.$emit("update:startDate", new Date(value));
      },
    },
    mEndDate: {
      get() {
        return this.endDate;
      },
      set(value) {
        this.$emit("update:endDate", new Date(value));
      },
    },
  },
  methods: {
    onStartDateFocus,
    onEndDateFocus,
    onDateChange,
  },
};

function onDateChange() {
  this.$emit("edit", true);
}

function onStartDateFocus() {
  this.$refs.startDateObj.show();
}

function onEndDateFocus() {
  this.$refs.endDateObj.show();
}
</script>

<style scoped>
::v-deep.v-text-field .v-input__control .v-input__slot {
  min-height: 30px !important;
  display: flex !important;
  align-items: center !important;
  font-size: 14px;
}
/* 
::v-deep .e-date-wrapper {
  border: 1px solid gray !important;
  border-radius: 4px !important;
  padding-left: 5px !important;
  padding-right: 5px !important;
  height: 30px;
  font-size: 14px !important;
  background-color: white !important;
} */

/* rgba(0, 0, 0, 0.38) */

::v-deep .e-input-group.e-control-wrapper,
.e-input-group.e-control-wrapper:hover {
  border-bottom-width: 0px !important;
}

::v-deep .e-date-icon.e-icons {
  /* display: none; */
  margin-bottom: 0px !important;
  padding-bottom: 0px !important;
}

::v-deep .e-input-group-icon.e-date-icon {
  /* font-size: 14px !important; */
}

::v-deep .theme--light.v-sheet--outlined {
  border-color: gray;
}

::v-deep .e-input-group,
.e-input-group.e-control-wrapper {
  margin-bottom: 0px;
}
.date-card {
  border-color: rgba(0, 0, 0, 0.38);
}
</style>